'use client';

import { Image } from '@/components/client';
import { useAdpopcorn } from '@/modules/adpopcorn';

export const WelloPointQuickMenuItem = () => {
  const { isExternalWebview, onClick, isOpening } = useAdpopcorn({
    placement: 'HOME_QUICK_MENU',
  });

  if (isExternalWebview) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isOpening}
      className="group flex w-64 shrink-0 flex-col items-center gap-6 py-8 disabled:opacity-60 xl:w-auto"
    >
      <div className="overflow-hidden rounded-medium">
        <Image
          src="/assets/pngs/wello-point-receive.png"
          alt="혜택"
          width={48}
          height={48}
          sizes="48px"
          className="size-48 transition-transform duration-200 ease-out group-hover:scale-110"
        />
      </div>
      <span className="whitespace-nowrap font-500 text-Gray-700 typo-caption2">
        혜택
      </span>
    </button>
  );
};
